const MINI_KEY = 'drawer.miniVariant';
const HIDE_UNUSED_KEY = 'drawer.hideUnused';

function readMini(): boolean {
  try {
    return localStorage.getItem(MINI_KEY) === '1';
  } catch (err) {
    return false;
  }
}

/** Default on — hide DevScrum / SMS / IPSet / QC from the sidemenu. */
function readHideUnused(): boolean {
  try {
    const raw = localStorage.getItem(HIDE_UNUSED_KEY);
    if (raw === null) {
      return true;
    }
    return raw === '1';
  } catch (err) {
    return true;
  }
}

function persistFlag(key: string, value: boolean): void {
  try {
    localStorage.setItem(key, value ? '1' : '0');
  } catch (err) {
    // Ignore private-mode failures.
  }
}

export type DrawerState = {
  visible: boolean;
  mini: boolean;
  hideUnused: boolean;
};

const state: DrawerState = {
  visible: true,
  mini: readMini(),
  hideUnused: readHideUnused(),
};

export default {
  state,
  mutations: {
    SET_DRAWER(moduleState: DrawerState, payload: boolean): void {
      moduleState.visible = payload;
    },
    SET_DRAWER_MINI(moduleState: DrawerState, payload: boolean): void {
      moduleState.mini = payload;
      persistFlag(MINI_KEY, payload);
    },
    TOGGLE_DRAWER_MINI(moduleState: DrawerState): void {
      moduleState.mini = !moduleState.mini;
      persistFlag(MINI_KEY, moduleState.mini);
    },
    SET_DRAWER_HIDE_UNUSED(moduleState: DrawerState, payload: boolean): void {
      moduleState.hideUnused = payload;
      persistFlag(HIDE_UNUSED_KEY, payload);
    },
  },
};
